import React from "react";
import { motion } from "framer-motion";
import { PREMISE } from "@/constants/testIds";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1.05, ease: [0.22, 0.61, 0.36, 1], delay: i * 0.12 },
  }),
};

const BookPremise = () => {
  return (
    <section
      id="book-premise"
      data-testid={PREMISE.section}
      className="relative w-full py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          {/* Left margin label */}
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            custom={0}
            className="md:col-span-3"
          >
            <div className="flex md:flex-col items-start gap-4">
              <span className="rule rule-cinder" aria-hidden="true" />
              <p className="overline">The Premise</p>
            </div>
          </motion.div>

          {/* Reading column */}
          <div className="md:col-span-9 max-w-2xl">
            <motion.h2
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={1}
              data-testid={PREMISE.heading}
              className="font-display text-[#F3EFEA] text-4xl sm:text-5xl md:text-6xl leading-[1.04] tracking-[-0.02em]"
            >
              Book I:{" "}
              <span className="italic text-[#D9D4CD] font-light">Echoes of Cinder</span>
            </motion.h2>

            <motion.p
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={2}
              data-testid={PREMISE.intro}
              className="drop-intro mt-10"
            >
              A relic has been stolen from the architecture of creation.
            </motion.p>

            <motion.div
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={3}
              data-testid={PREMISE.body}
              className="mt-8 space-y-7 text-[#D9D4CD] text-base sm:text-lg leading-relaxed font-light"
            >
              <p>
                Across the Continuum, worlds begin to disappear in ways no army
                can explain. Records fracture. Names fail. Survivors remember
                things no archive can prove.
              </p>
              <p>
                Jerem Stillwagner, a disgraced Ferrum pilot carrying the ghosts
                of old wars, is drawn into the first open rupture of a conflict
                the Alliance has spent centuries trying to forget. Beside him
                stand rival champions, ancient species, living machines, and
                powers that do not yet understand the scale of what has
                awakened.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookPremise;
